module.exports = __webpack_public_path__ + "ade72e9ffcb51198a0a116b4eb42eddd.MP3";